import axios from "axios";

import StringUtil from "../../../src/app/StringUtil";
import ReferenceData from "../constants/ReferenceData";

export interface GroupDetails {
    dbName: string;
    definedBenefitsType: null;
    groupClientId: string;
    groupClientName: string;
    indId: string;
    irsrlCode: string;
    isDefinedBenefitPlan: boolean;
    isGroupSuppressReporting: null;
    isPlanRoutingTRSRequired: boolean;
    minimumDivPassthruAmt: null;
    planId: string;
    planName: string;
    planType: null;
    productId: string;
    productName: string;
    providingCompany: string;
    statusCode: null;
    statusSubcode: null;
    vendorPlanId: null;
    vendorPlanType: null;
}

export interface AccountDetails {
    accountURL: string;
    accuCode: string;
    age: number;
    asOfDate: null;
    birthDate: Date;
    currentContext: null;
    dbName: string;
    defaultPlan: boolean;
    definedBenefit: null;
    definedBenefitPlan: boolean;
    description: string;
    firstName: string;
    groupDetails: GroupDetails;
    groupId: string;
    hsaCoverageType: null;
    hsaPlan: boolean;
    hsaStatus: null;
    individualId: string;
    investmentBalance: null;
    isGAServiceForRollOverIRATileEnabled: boolean;
    lastName: string;
    middleName: null;
    name: string;
    nqEligibleToEnrollInd: null;
    pcapAccountClosedDate: null;
    pcapAccountId: null;
    pcapEnrollmentStatus: null;
    pinAuthCode: "U" | "I";
    planType: null;
    primaryParticipant: boolean;
    productId: string;
    realTimeBalanceCallFailed: boolean;
    restrictedBalance: boolean;
    shadowPlan: boolean;
    showNqLinkInd: null;
    siteName: null;
    statusCode: string;
    statusSubCode: string;
    subsetName: null;
    totalBalance: number;
    vestedBalance: number;
    vestedPercent: null;
    ytdAmount: null;
}

type GetAccountDetailsArgs = {
    groupId: string;
    individualId: string;
};

const getAccountDetails = async ({ individualId, groupId }: GetAccountDetailsArgs) => {
    const url = StringUtil.supplant(ReferenceData.ACCOUNT_DETAILS_URL, {
        individualId,
        groupId
    });
    const response = await axios.get<AccountDetails>(url);

    return response.data;
};

export default getAccountDetails;
